module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/og_page2.bef8f3b6.jpg";